import type { Dayjs } from 'dayjs'

// Extend the ILocale interface to support function for monthsShort
interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  weekdaysShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  name: 'lv',
  weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
  months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
    '_'
  ),
  weekStart: 1,
  weekdaysShort: (dayjsInstance: Dayjs, format: string): string => {
    const standard = 'Sv_Pi_Ot_Tr_Ce_Pk_Se'.split('_')
    const extended = 'Sv_P_O_T_C_Pk_S'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.day()]
    } else {
      return standard[dayjsInstance.day()]
    }
  },
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const standard = 'Jan_Feb_Mar_Apr_Mai_Jūn_Jūl_Aug_Sep_Okt_Nov_Dec'.split('_')
    const extended = 'Janv._Febr._Marts_Apr._Maijs_Jūn._Jūl._Aug._Sept._Okt._Nov._Dec.'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  },
  weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
  ordinal: (n) => n,
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD.MM.YYYY.',
    LL: 'YYYY. [gada] D. MMMM',
    LLL: 'YYYY. [gada] D. MMMM, HH:mm',
    LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
  },
  relativeTime: {
    future: 'pēc %s',
    past: 'pirms %s',
    s: 'dažām sekundēm',
    m: 'minūtes',
    mm: '%d minūtēm',
    h: 'stundas',
    hh: '%d stundām',
    d: 'dienas',
    dd: '%d dienām',
    M: 'mēneša',
    MM: '%d mēnešiem',
    y: 'gada',
    yy: '%d gadiem'
  }
}

export default locale
